import { render, staticRenderFns } from "./SentimentTrend.vue?vue&type=template&id=5a76332a&scoped=true"
import script from "./SentimentTrend.vue?vue&type=script&lang=js"
export * from "./SentimentTrend.vue?vue&type=script&lang=js"
import style0 from "./SentimentTrend.vue?vue&type=style&index=0&id=5a76332a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a76332a",
  null
  
)

export default component.exports